import { useMutation } from '@tanstack/react-query';
import { downloadReportPdf } from '../common/api/reports';
import { Button } from '@cloudscape-design/components';
import { PlaceReport } from '../common/types';

export type ReportDownloadButtonProps = {
  item: PlaceReport;
  period: string;
  variant?: 'button' | 'link' | 'icon' | 'inline-link' | 'inline-icon';
};

export function ReportDownloadButton(props: ReportDownloadButtonProps) {
  const { item, period } = props;

  const downloadQuery = useMutation({
    mutationFn: () => downloadReportPdf(item.uuid, period),
    onSuccess: (data: string) => {
      if (data) {
        const url = data;
        const a = document.createElement('a');
        a.href = url;
        // in the format 02-03-25
        const reportDate = new Date(item.created_at + 'Z');
        const dateStr = reportDate.toLocaleDateString('en-US', {
          month: '2-digit',
          day: '2-digit',
          year: '2-digit',
        });
        a.download = `${item.place?.name}-${dateStr}-${period}.pdf`;
        a.target = '_blank';
        a.click();

        // Revoke the object URL to free up memory
        URL.revokeObjectURL(url);
      }
    },
  });

  return props.variant === 'button' ? (
    <Button
      variant="primary"
      onClick={() => {
        downloadQuery.mutate();
      }}
      loading={downloadQuery.isPending}
    >
      Download PDF
    </Button>
  ) : (
    <Button
      variant={props.variant}
      onClick={() => {
        downloadQuery.mutate();
      }}
      iconName="download"
      loading={downloadQuery.isPending}
    />
  );
}
